<template>
	<div class="title-block">
		<div class="title-block__left">
            <div class="title-block__title">Редактор открыток</div>
			<a :href="route_create" class="title-block__btn btn-add btn-primary btn">Добавить</a>
		</div>
	</div>
	<table class="table align-middle">
		<thead>
			<tr>
				<th scope="col">Название</th>
				<th scope="col">Действия</th>
			</tr>
		</thead>
		<tbody>
			<tr v-for="data in templates">
				<td><a v-bind:href="'/organizational/gratters-constructor/'+ data.id">{{ data.name }}</a></td>
				<td class="d-flex flex-row align-items-center">
					<div>
                        <button @click.prevent="editElement(data.id)" class="table-action table-action_edit m-auto align-middle" title="Редактировать"></button>
					</div>
					<div>
                        <button @click.prevent="showModalDelete(data.id)" class="table-action table-action_delete m-auto align-middle" title="Удалить"></button>
					</div>
				</td>
			</tr>
		</tbody>
	</table>

	<modal-window ref="modaldelete">
		<template v-slot:title>
			<div class="modal-header">
				<h5 class="modal-title w-100 text-center">Вы точно хотите удалить шаблон?</h5>
			</div>
		</template>
		<template v-slot:body>
			<div class="modal-body">
				<p class="text-center color-light">Данное действие нельзя отменить</p>
			</div>
		</template>
		<template v-slot:footer>
			<div class="modal-footer">
				<button type="button" class="btn btn-primary" @click.self="deleteElement(modaldata.id)">Удалить</button>
				<button type="button" class="btn btn-outline-dark" @click.self="closeModalDelete">Отменить</button>
			</div>
		</template>
	</modal-window>

</template>

<script>

import ModalWindow from './GrattersModal.vue';

export default {
    name: 'GrattersListComponent',
	components: {
		ModalWindow
	},
    props: {
        route_list: String,
        route_create: String,
    },
	data: () => {
        return {
            templates: [],
			modaldata: '',
        };
    },
	methods: {
        editElement: function (id) {
			document.location = '/organizational/gratters-constructor/edit/' + id;
		},

		deleteElement: function (id) {
			axios.delete('/organizational/gratters-constructor/' + id, {})
				.then(res => {
					if(res.data.status == 'ok') {
						document.location = '/organizational/gratters-constructor/';
					}
				});
		},
		showModalDelete: function (id) {
			console.log(id);
			this.modaldata = {id: id};
			this.$refs.modaldelete.show = true;
		},
		closeModalDelete: function () {
			this.$refs.modaldelete.show = false;
		},
	},
	mounted() {
		axios.get(this.route_list, {})
			.then(res => {
				this.templates = res.data.items;
			});
    }
}
</script>
